var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('DashBoard',{attrs:{"TIME":"TOÀN BỘ"}}),_c('vue-headful',{attrs:{"title":"REPORT ALL"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }